var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForum(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5002 6.91253C16.4452 6.90336 16.3811 6.90336 16.3261 6.91253C15.0611 6.8667 14.0527 5.83086 14.0527 4.54753C14.0527 3.23669 15.1069 2.18253 16.4177 2.18253C17.7286 2.18253 18.7827 3.24586 18.7827 4.54753C18.7736 5.83086 17.7652 6.8667 16.5002 6.91253Z",
    stroke: "#6F767E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5558 13.5859C16.8117 13.7967 18.1958 13.5767 19.1675 12.9259C20.46 12.0642 20.46 10.6525 19.1675 9.79086C18.1867 9.14002 16.7842 8.92002 15.5283 9.14002",
    stroke: "#6F767E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.47293 6.91253C5.52793 6.90336 5.5921 6.90336 5.6471 6.91253C6.9121 6.8667 7.92043 5.83086 7.92043 4.54753C7.92043 3.23669 6.86626 2.18253 5.55543 2.18253C4.2446 2.18253 3.19043 3.24586 3.19043 4.54753C3.1996 5.83086 4.20793 6.8667 5.47293 6.91253Z",
    stroke: "#6F767E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41698 13.5859C5.16114 13.7967 3.77698 13.5767 2.80531 12.9259C1.51281 12.0642 1.51281 10.6525 2.80531 9.79086C3.78615 9.14002 5.18864 8.92002 6.44448 9.14002",
    stroke: "#6F767E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0002 13.76C10.9452 13.7509 10.8811 13.7509 10.8261 13.76C9.56107 13.7142 8.55273 12.6784 8.55273 11.395C8.55273 10.0842 9.6069 9.03003 10.9177 9.03003C12.2286 9.03003 13.2827 10.0934 13.2827 11.395C13.2736 12.6784 12.2652 13.7234 11.0002 13.76Z",
    stroke: "#6F767E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33266 16.6475C7.04016 17.5092 7.04016 18.9209 8.33266 19.7825C9.79932 20.7634 12.201 20.7634 13.6677 19.7825C14.9602 18.9209 14.9602 17.5092 13.6677 16.6475C12.2102 15.6759 9.79932 15.6759 8.33266 16.6475Z",
    stroke: "#6F767E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForum);
export default __webpack_public_path__ + "static/media/forum.6622b073eb9e39d583300dd9b98fe4d6.svg";
export { ForwardRef as ReactComponent };